import { Button } from '../ui/button';
import { Menu, X, Leaf } from 'lucide-react';

export const MobileHeader = ({ isMenuOpen, onToggleMenu }) => (
  <header className="md:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b border-[#D1D1CD] z-50">
    <div className="flex items-center justify-between px-4 h-full">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-[#2E4632] rounded-full flex items-center justify-center">
          <Leaf className="w-4 h-4 text-white" />
        </div>
        <span className="text-lg font-bold text-[#2E4632]" style={{ fontFamily: 'Manrope, sans-serif' }}>
          FarmWorker
        </span>
        <span
          data-testid="beta-badge-mobile"
          className="text-[9px] font-semibold tracking-wide text-[#2E4632] bg-[#2E4632]/10 border border-[#2E4632]/25 rounded-full px-1.5 py-0.5"
        >
          BETA
        </span>
      </div>
      <Button
        variant="ghost"
        size="icon"
        data-testid="mobile-menu-btn"
        onClick={onToggleMenu}
        className="h-10 w-10"
      >
        {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </Button>
    </div>
  </header>
);
